import { ComponentProps, FC } from 'react';

import { Container } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface DocumentContainerProps extends ComponentProps<typeof Container> {
  isTridion: boolean;
}

export const DocumentContainer: FC<DocumentContainerProps> = ({
  isTridion,
  className,
  ...props
}) => (
  <Container
    {...props}
    className={cn(
      'w-full! p-0!',
      isTridion ? 'm-0!' : 'mx-auto! my-0!',
      className,
    )}
  />
);
